@file:OptIn(ExperimentalTime::class)

package com.macrofocus.eflux.network.lightning

import org.locationtech.jts.geom.Point
import org.molap.dataframe.ListDataFrameBuilder
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

data class Lightning(val strokeTime: Instant, val strokeCurrent: Double?,
                     /**
                      * 1 represents cloud-to-ground (CG) lightning
                      * 2 represents cloud-to-cloud (CC) lightning
                      * 3 represents intra-cloud (IC) lightning
                      */
                     val lightningType: Int,
                     val geometry: Point) {
    companion object {
        val dataFrameBuilder: ListDataFrameBuilder<Lightning, String>.() -> Unit = {
            "strokeTime" to { strokeTime }
            "strokeCurrent" to { strokeCurrent }
            "lightningType" to { lightningType }
            "geometry" to { geometry }
        }
    }
}